import { app } from '../../../config'
/* =============================================
 * Private helpers
 * ============================================= */
/**
 * Support POST request pattern wrapper.
 * @param {Object} params Parameter object to merge with common params.
 * See postRESTParams method for more info.
 */

const _supportRESTPOST = async (params, url) => {
  const result = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: JSON.stringify(params)
  })
    .then(response => response.json())
    .catch(error => {
      console.error('error', error)
      return { error }
    })

  return result
}

const onSupportRequest = async params => {
  const supportWebHookURL = app.webhooks.support_request
  const result = await _supportRESTPOST(params, supportWebHookURL)
  return result
}

const onCancelationRequest = async params => {
  const cancelationNotificationWebHookURL = app.webhooks.subscription
  const result = await _supportRESTPOST(
    params,
    cancelationNotificationWebHookURL
  )
  return result
}
export { onSupportRequest, onCancelationRequest }
